module.exports = __webpack_public_path__ + "static/media/star-big-04.9b56f524.svg";